angular
.module('app.services')
.factory('logger', [
  function() {

    const toastrOptions = {
      "closeButton": true,
      "positionClass": "toast-top-right",
      "timeOut": "6000"
    };

    let logIt = function(message, type, options = {}) {
      toastr.options = Object.assign({}, toastrOptions, options);;
      return toastr[type](message);
    };

    let instance = {
      log: function(message, options = {}) {
        logIt(message, 'info', options);
      },
      logWarning: function(message, options = {}) {
        logIt(message, 'warning',  options);
      },
      logSuccess: function(message, options = {}) {
        logIt(message, 'success',  options);
      },
      logError: function(message, options = {}) {
        logIt(message, 'error',  options);
      },
      notify: (type, message, options = {}) =>{
        switch (type) {
          case 'info':
          default:
            instance.log(message, options);
            break;
          case 'success':
            instance.logSuccess(message, options);
            break;
          case 'warning':
            instance.logWarning(message, options);
            break;
          case 'error':
            instance.logError(message, options);
        }
      }
    };

    return instance;
  }
]);



// WEBPACK FOOTER //
// ./scripts/shared/services/logger.js